import { Component } from '@angular/core';

import { PriceOddsButtonComponent } from '../../../shared/components/priceOddsButton/price-odds-button.component';
import { PriceOddsSAClassDirective } from '../../../shared/components/priceOddsButtonStandalone/price-odds-class-sa.directive';
import { PriceOddsSAValueDirective } from '../../../shared/components/priceOddsButtonStandalone/price-odds-value-sa.directive';
import { LocaleDirective } from '../../../shared/directives/locale.directive';

@Component({
    selector: 'price-odds-button-srm',
    templateUrl: './price-odds-button-srm.component.html',
    imports: [PriceOddsSAClassDirective, PriceOddsSAValueDirective, LocaleDirective],
})
export class PriceOddsButtonSRMComponent extends PriceOddsButtonComponent {}
